import { Typography } from '@mui/material';
import { DateContainer, DateInstance } from 'src/v2/components/ui/notifications';

import { NormalLink } from '~components/shared/link';
import { primaryColors } from '~components/theme/styles/colors';

export const notificationsComponents = [
  <DateContainer unixTime={1670467719} key="0">
    <Typography variant={'body3'} sx={{ color: primaryColors[700] }}>
      Vesta is increasing GLP mint cap to 10M VST gradually over the next couple of weeks. On{' '}
      <DateInstance unixTime={1670554800} />, we&apos;ll push the first mint cap increase from 5M to 6M. Get
      ready!
    </Typography>
  </DateContainer>,
  <DateContainer unixTime={1669404439} key="1">
    <Typography variant={'body3'} sx={{ color: primaryColors[700] }}>
      Vesta Reference Rate is set to be online at Nov 25 1 PM PST. During the migration, the only actions
      available will be removing or adding collateral. We are expecting it to take 5-15 minutes. Learn more
      about Vesta Reference Rate{' '}
      <NormalLink
        target="_blank"
        rel="noopener noreferrer"
        href="https://medium.com/@VestaFinance/introducing-vesta-reference-rate-f676883166c3"
      >
        here
      </NormalLink>
      .
    </Typography>
  </DateContainer>,
  <DateContainer unixTime={1667878235} key="2">
    <Typography variant={'body3'} sx={{ color: primaryColors[700] }}>
      Amidst complicating situation around the FTX / Alameda saga, we are halting minting of VST using renBTC
      until further notice to protect all Vesta users.
    </Typography>
  </DateContainer>,
  <DateContainer unixTime={1667878235} key="3">
    <Typography variant={'body3'} sx={{ color: primaryColors[700] }}>
      The proposal for Vesta Reference Rate has passed! We will publish an announcement soon regarding
      implementation. Learn more about Vesta Reference Rate{' '}
      <NormalLink
        target="_blank"
        rel="noopener noreferrer"
        href="https://medium.com/@VestaFinance/introducing-vesta-reference-rate-f676883166c3"
      >
        here
      </NormalLink>
      .
    </Typography>
  </DateContainer>,
  <DateContainer unixTime={1667557835} key="4">
    <Typography variant={'body3'} sx={{ color: primaryColors[700] }}>
      Vesta Reference Rate is now at voting stage.{' '}
      <NormalLink
        target="_blank"
        rel="noopener noreferrer"
        href="https://medium.com/@VestaFinance/introducing-vesta-reference-rate-f676883166c3"
      >
        Learn more
      </NormalLink>{' '}
      about Vesta Reference Rate and please visit{' '}
      <NormalLink
        target="_blank"
        rel="noopener noreferrer"
        href="https://snapshot.org/#/vestafinance.eth/proposal/0x02ada853586a9fa9b8917952aa88c4dea2cd935d4282b9bf6edaa39301d8ec98"
      >
        snapshot
      </NormalLink>{' '}
      for voting.
    </Typography>
  </DateContainer>,
  <DateContainer unixTime={1665225035} key="5">
    <Typography variant={'body3'} color={primaryColors[700]}>
      Vesta is potentially disabling redemption and adding interest rate. Learn more{' '}
      <NormalLink
        target="_blank"
        rel="noopener noreferrer"
        href="https://curia.vestafinance.xyz/t/rfc-adding-interest-rate-to-help-with-vst-peg/125"
      >
        here
      </NormalLink>
      .
    </Typography>
  </DateContainer>,
];
